// extracted by mini-css-extract-plugin
export default {"spinner":"o7Soo94L","inner":"fnzgQDjn","spin":"dPrfSpVS","white":"ZwvOHvLC"};